import(/* webpackMode: "eager", webpackExports: ["Breadcrumb","Skeleton","Empty"] */ "__barrel_optimize__?names=Breadcrumb,Empty,Skeleton!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Product/ContactBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Product/imageGallery.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/Product/ImageGallerySwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Product/Information.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Product/product-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Product/ProductDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Product/SimilarProductsCard.tsx");
